// Source: data/econ-model-outputs-snapshot.csv (Plan A, World).
// Hand-extracted rows 121, 129, 29, 45 from the spreadsheet snapshot
// (Humans on cognitive (Hc), Humans on physical (Hp), AI labor A_eff (HE),
// Robot labor R_p (HE)). Units: human-equivalents.
// If the spreadsheet changes, re-run scripts/downloadEconModelOutputs.ts
// and update these numbers.

export type LaborMixDatum = {
  year: number
  humansCog: number
  humansPhys: number
  aiCog: number
  robotPhys: number
}

export const LABOR_MIX_DATA: LaborMixDatum[] = [
  { year: 2025, humansCog: 2098844786,  humansPhys: 1401155214, aiCog: 34000000,     robotPhys: 10000000 },
  { year: 2026, humansCog: 2083615683,  humansPhys: 1396545839, aiCog: 89397000,     robotPhys: 12760000 },
  { year: 2027, humansCog: 2071195223,  humansPhys: 1399613465, aiCog: 202060320,    robotPhys: 15960000 },
  { year: 2028, humansCog: 2050974116,  humansPhys: 1405838708, aiCog: 407160000,    robotPhys: 19890000 },
  { year: 2029, humansCog: 2031132294,  humansPhys: 1412110277, aiCog: 630000000,    robotPhys: 25480000 },
  { year: 2030, humansCog: 2032431141,  humansPhys: 1427128873, aiCog: 1500000000,   robotPhys: 34500000 },
  { year: 2031, humansCog: 1992072894,  humansPhys: 1432999341, aiCog: 2265120000,   robotPhys: 60690000 },
  { year: 2032, humansCog: 2021770613,  humansPhys: 1495433977, aiCog: 7123810680,   robotPhys: 129600000 },
  { year: 2033, humansCog: 2116379450,  humansPhys: 1619784095, aiCog: 30972978750,  robotPhys: 340000000 },
  { year: 2034, humansCog: 2150068662,  humansPhys: 1781106395, aiCog: 1.14e11,      robotPhys: 972900000 },
  { year: 2035, humansCog: 1884833701,  humansPhys: 1951943924, aiCog: 1.94e11,      robotPhys: 2500000000 },
  { year: 2036, humansCog: 1811623156,  humansPhys: 1733634316, aiCog: 2.79e11,      robotPhys: 6328000000 },
  { year: 2037, humansCog: 1620520327,  humansPhys: 1363437979, aiCog: 3.32e11,      robotPhys: 16368000000 },
  { year: 2038, humansCog: 1400456570,  humansPhys: 1072430298, aiCog: 3.52e11,      robotPhys: 42500000000 },
  { year: 2039, humansCog: 1223490848,  humansPhys: 1013606749, aiCog: 3.67e11,      robotPhys: 1.10e11 },
  { year: 2040, humansCog:  920802548,  humansPhys:  884973295, aiCog: 4.00e11,      robotPhys: 2.80e11 },
]
